import { useEffect } from "react";
import { syncPushNotifications } from "../firebase/push";

// Registers this browser for push notifications once the user is signed in,
// as the app's usePushNotification does on its first screen.
export default function usePushNotification() {
  useEffect(() => {
    syncPushNotifications();
  }, []);
}
